export type AdminEventFilter = {
  subjectType?: string
  subjectId?: string
  kind?: string
  retention?: '' | 'ephemeral' | 'persistent'
  query?: string
  after?: string
  before?: string
  limit?: number
}

export type EventSubject = {
  type: string
  id: string
}

export function buildAdminEventsURL(filter: AdminEventFilter) {
  const params = new URLSearchParams()
  if (filter.subjectType?.trim()) params.set('subject_type', filter.subjectType.trim())
  if (filter.subjectId?.trim()) params.set('subject_id', filter.subjectId.trim())
  if (filter.kind?.trim()) params.set('kind', filter.kind.trim())
  if (filter.retention) params.set('retention', filter.retention)
  if (filter.query?.trim()) params.set('q', filter.query.trim())
  if (filter.after) params.set('after', filter.after)
  if (filter.before) params.set('before', filter.before)
  params.set('limit', String(filter.limit ?? 100))
  return `/v0/admin/events?${params.toString()}`
}

export function eventSubjectLabel(subject: EventSubject) {
  return `${subject.type} #${subject.id}`
}
